const InfoField = ({
    label,
    value,
    className = "",
    valueClassName = "",
    labelClassName = "",
    labelExtra = null,
}) => {
    return (
        <div className={`mb-3 w-full min-w-0 ${className}`}>
            <div className="flex items-center justify-between gap-1 mb-1">
                <p
                    className={`text-sm font-semibold text-custom_gray_font ${labelClassName}`}
                >
                    {label}
                </p>

                {labelExtra && (
                    <span className="flex items-center">
                        {labelExtra}
                    </span>
                )}
            </div>

            <p
                className={`
                    px-3 py-1.5 border rounded
                    whitespace-nowrap overflow-hidden text-ellipsis
                    ${valueClassName}
                `}
                style={{ fontSize: "clamp(0.75rem, 2.5vw, 0.875rem)" }}
                title={String(value)}
            >
                {value}
            </p>
        </div>
    );
};

export default InfoField;
